import { css } from 'styled-components';

import { brandColors } from 'src/theme/constants/brand-colors';

export const SEGMENTED_SELECTED_COLOR = `var(--dcm-cms-segmented-selected-color, ${brandColors.moss})`;
export const SEGMENTED_SELECTED_BG = `var(--dcm-cms-segmented-selected-bg, color-mix(in srgb, ${brandColors.moss} 10%, #fff))`;

/** Connected, content-sized choices. Private variables retain each widget's existing public style hooks. */
export const segmentedControlCss = css`
  display: flex;
  gap: 0;
  border: var(--dcm-cms-segmented-border-width, 1px) solid
    var(--_cms-segmented-border, var(--dcm-cms-segmented-border-color, var(--puck-color-border, #d0d4d8)));
  border-radius: var(--_cms-segmented-radius, var(--dcm-cms-segmented-radius, var(--puck-radius-m, 6px)));

  && > button {
    box-sizing: border-box;
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    border: 0;
    border-radius: var(--dcm-cms-segmented-inner-radius, 0);
    padding: var(--dcm-cms-segmented-padding, 12px 8px);
    background: var(--_cms-segmented-bg, var(--dcm-cms-segmented-bg, var(--puck-field-color-bg, #fff)));
    color: var(--_cms-segmented-color, var(--dcm-cms-segmented-color, var(--puck-color-text, #121516)));
    font-family: var(--dcm-cms-segmented-font-family, var(--puck-font-family, inherit));
    font-size: var(--dcm-cms-segmented-font-size, var(--puck-font-size-xxs, 14px));
    line-height: 1.15;
    font-weight: var(--dcm-cms-segmented-font-weight, 400);
    text-align: center;
    white-space: normal;
    overflow-wrap: normal;
    box-shadow: none;
    cursor: pointer;
  }

  && > button + button {
    border-left: var(--dcm-cms-segmented-border-width, 1px) solid
      var(--_cms-segmented-border, var(--dcm-cms-segmented-border-color, var(--puck-color-border, #d0d4d8)));
  }

  && > button:first-child {
    border-top-left-radius: var(--_cms-segmented-radius, var(--dcm-cms-segmented-radius, var(--puck-radius-m, 6px)));
    border-bottom-left-radius: var(--_cms-segmented-radius, var(--dcm-cms-segmented-radius, var(--puck-radius-m, 6px)));
  }

  && > button:last-child {
    border-top-right-radius: var(--_cms-segmented-radius, var(--dcm-cms-segmented-radius, var(--puck-radius-m, 6px)));
    border-bottom-right-radius: var(
      --_cms-segmented-radius,
      var(--dcm-cms-segmented-radius, var(--puck-radius-m, 6px))
    );
  }

  && > button[aria-selected='true'],
  && > button[aria-pressed='true'] {
    background: var(--_cms-segmented-selected-bg, ${SEGMENTED_SELECTED_BG});
    color: var(--_cms-segmented-selected-color, ${SEGMENTED_SELECTED_COLOR});
  }

  && > button:focus-visible {
    outline: 2px solid
      var(--_cms-segmented-focus, var(--dcm-cms-segmented-focus, var(--puck-color-focus-ring, #0b99e6)));
    outline-offset: 2px;
    position: relative;
    z-index: 1;
  }

  && > button:disabled {
    cursor: not-allowed;
    opacity: var(--dcm-cms-segmented-disabled-opacity, 0.55);
  }
`;
